import React from 'react';
import { ShoppingCart, ArrowLeft } from 'lucide-react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';

const CartHeader = ({ cart, getCartTotal, onBack, formatPrice }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  // Anzahl POSITIONEN (Zeilen), nicht Summe der Mengen
  const itemCount = Array.isArray(cart) ? cart.length : 0;

  return (
    <div className="relative">
      {/* Header Background */}
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gray-900/20 border-b border-white/10 backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.3)]'
        : 'bg-white border-b border-slate-200'
      }`}></div>
      {/* Dark mode subtle gradient accent — kein Lavendel, kein Navy */}
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-r from-blue-900/5 via-transparent to-blue-900/5'
        : ''
      }`}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">

          {/* Left: Icon + Title + Demo-Sync-Zeile */}
          <div className="flex items-center gap-4 min-w-0">
            {/* Cart Icon */}
            <div className={`flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center border ${
              isDarkMode
                ? 'bg-gradient-to-br from-blue-600/60 via-blue-700/50 to-blue-800/60 backdrop-blur-xl border-white/20'
                : 'bg-brand/10 border-brand/20'
            }`}>
              <ShoppingCart className={`w-5 h-5 ${isDarkMode ? 'text-white/90' : 'text-brand'}`} />
            </div>

            <div className="min-w-0">
              {/* Titel */}
              <h1 className={`text-2xl font-bold leading-tight ${isDarkMode
                ? 'bg-gradient-to-r from-white via-blue-200 to-white bg-clip-text text-transparent'
                : 'text-slate-900'
              }`}>
                {t('cart.title')}
              </h1>

              {/* Subtitle: Artikel + Gesamtpreis */}
              {cart.length > 0 && (
                <p className={`text-sm ${isDarkMode ? 'text-white/60' : 'text-slate-500'}`}>
                  {itemCount} {t('cart.items')} &bull; {formatPrice(getCartTotal(), 'EUR')}
                </p>
              )}
            </div>
          </div>

          {/* Right: Zurück-Button */}
          <button
            onClick={onBack}
            className={`flex-shrink-0 relative group/back overflow-hidden rounded-xl transition-all duration-200 transform hover:scale-[1.01] active:scale-[0.99] ${
              isDarkMode
                ? ''
                : 'bg-slate-100 hover:bg-slate-200 border border-slate-200'
            }`}
            style={isDarkMode ? {
              background: 'linear-gradient(135deg, rgba(71,85,105,0.6) 0%, rgba(75,85,99,0.6) 50%, rgba(71,85,105,0.6) 100%)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.3)',
              boxShadow: '0 4px 16px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)'
            } : {}}
          >
            {/* Hover overlay — nur Dark */}
            <div
              className={`absolute inset-0 rounded-xl transition-all duration-200 opacity-0 group-hover/back:opacity-100 ${isDarkMode ? '' : 'hidden'}`}
              style={isDarkMode ? {
                background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%)'
              } : {}}
            ></div>
            <div className={`relative z-10 px-4 py-2 flex items-center gap-2 font-medium text-sm ${
              isDarkMode ? 'text-white' : 'text-slate-700'
            }`}>
              <ArrowLeft className="w-4 h-4" />
              {t('cart.back')}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartHeader;
